module.exports = __webpack_public_path__ + "static/media/Coffin.5a69192c.svg";